import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../../Utils/toastContext";
import { useDispatch, useSelector } from "react-redux";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import AddressAutocomplete from "../../../Components/addressInput/address-input";
import { useNavigate, useLocation } from "react-router-dom";
import AddUserPopup from "../../../Components/add-joint-accounts/Add-User-Popup";

const TrustInfo = ({ setCurrentStep }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [accountType, setAccountType] = useState(1);
  const [jointAccountUser, setJointAccountUser] = useState(1);
  const [accountTypeLabel, setAccountTypeLabel] = useState("Individual");
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [advisorId, setAdvisorId] = useState("");
  const [isAdvisorExist, setIsAdvisorExist] = useState(true);
  const [advisorName, setAdvisorName] = useState("Brian	Vaughan");
  const [fullName, setfullName] = useState("");
  const [formerNames, setFormerNames] = useState([]);
  const [newFormerName, setFormerName] = useState("");
  const [recommendedBy, setRecommendedBy] = useState("");
  const [DoI, setDoI] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedAccountType, setpreselectedAccountType] = useState({
    value: 1,
    label: "Regulated Trust",
  });
  const [toCurrency, setToCurrency] = useState(2);
  const [toCurrencyText, setToCurrencyText] = useState("AUD");
    const [fullSettlorName, setFullSettlorName] = useState("");

  const [jointAccountUserLabel, setJointAccountUserLabel] = useState("");
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [countryType, setCountryType] = useState(1);
  const [countryTypeLabel, setCountryTypeLabel] = useState("Australia");
  const [purpose, setPurpose] = useState("");

  const [countryCodeData, setCountryCodeData] = useState([
    {
      value: 1,
      label: "Australia",
    },
  ]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 1,
    label: "Australia",
  });
    const [fileAbn, setFileAbn] = useState(null);
  
  const [countryCode, setCountryCode] = useState(1);
  const [countryCodeText, setCountryCodeText] = useState("Australia");
  const [redAddress, setRedAddress] = useState("");
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [investmentAmountText, setInvestmentAmountText] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [stateText, setStateText] = useState("");
  const [abn, setAbn] = useState("");
  const [acn, setAcn] = useState("");
  const [trustTypeText, setTrustTypeText] = useState("");
  const [trustTypeID, setTrustTypeID] = useState("");

  const fileInputRef = useRef(null);
    const abnFileRef = useRef(null);

  const [preview, setPreview] = useState("/avatar.svg");
  const { showToast } = useToast();
  const [jointAccountId, setJointAccountId] = useState(null);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [actualData, setactualData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const containerRef = useRef(null);
  const [nameFromBirth, setNameFromBirth] = useState("yes");
  const [clientId, setClientId] = useState("INV1947534324");
  const [activity, setActivity] = useState(null);
  const [activityText, setActivityText] = useState("");
  const [otherActivity, setOtherActivity] = useState("");
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [companyTypeText, setCompanyTypeText] = useState("Proprietary Company");
  const [registeredAddress, setRegisteredAddress] = useState("");
  const [principalAddress, setPrincipalAddress] = useState("");
  const [companySecretary, setCompanySecretary] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [transactionLevel, setTransactionLevel] = useState("");
  const [source, setSource] = useState("");
  const [foreignRegistered, setForeignRegistered] = useState("yes");
  const [EIN, setEIN] = useState("");
  const [arbn, setArbn] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentAddress, setAgentAddress] = useState("");
  const [stockExchangeText, setStockExchangeText] = useState("");
  const [stockExchangeId, setStockExchangeId] = useState("");
  const [stockRegistered, setStockRegistered] = useState("yes");
  const [registrationNumber, setRegistrationNumber] = useState("");

  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  const [foreignAddress, setForeignAddress] = useState("");
  const [preSelectedCompanyType, setPreSelectedCompanyType] = useState({
    value: 1,
    label: "Proprietary Company",
  });
    const [fileThirdParty, setFileThirdParty] = useState(null);
  
    const [preselectedCountryType, setPreselectedCountryType] = useState({
      value: 1,
      label: "Australia",
    });
  const companyTypeData = [
    {
      value: 1,
      label: "Proprietary Company",
    },
    {
      value: 2,
      label: "Public Company",
    },
  ];
  const stateData = [
    {
      value: 1,
      label: "New South Wales(NSW)",
    },
  ];
  const stockExchangeData = [
    {
      value: 1,
      label: "USA - NASDAQ Stock Mark",
    },
  ];
  const businessActivityData = [
    {
      value: 1,
      label: "Capital Markets",
    },
    {
      value: 2,
      label: "Commodities",
    },
    {
      value: 3,
      label: "Financial Market",
    },
    {
      value: 4,
      label: "Real Estate",
    },
    {
      value: 5,
      label: "Stock Market",
    },
    {
      value: 6,
      label: "Others",
    },
  ];
    const businessNatureData = [
    {
      value: 1,
      label: "Accredited Investor",
    },
    {
      value: 2,
      label: "High Net-Worth Individual",
    },
    {
      value: 3,
      label: "Sophisticated Investor",
    },
    {
      value: 4,
      label: "Wholesale Investor",
    },
  ];
  const handleSelectCompanyType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setCompanyTypeId(selectedOption.value);
    setCompanyTypeText(selectedOption.label);
  };
    const handleDeleteFileAbn = () => {
    setFileAbn(null);
    if (abnFileRef.current) {
      abnFileRef.current.value = null;
    }
  };
    const handleFileChangeAbn = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAbn(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleSelectDomicileCountry = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setCountryCode(selectedOption.value);
    setCountryCodeText(selectedOption.label);
  };
  const handleNameForeignRegistered = (e) => {
    setForeignRegistered(e.target.value);
  };

  const handleStockRegistered = (e) => {
    setStockRegistered(e.target.value);
  };
  const handleSelectActivity = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setActivity(selectedOption.value);
    setActivityText(selectedOption.label);
  };

  const handleContinue = () => {
    // your logic like setCurrentStep(2), API calls, etc.
    handlesave();
    setCurrentStep(2);
  };
  const handleSelectBusinessNature = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setBusinessNature(selectedOption.value);
    setBusinessNatureText(selectedOption.label);
  };
  const handleSelectStateData = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setStateId(selectedOption.value);
    setStateText(selectedOption.label);
  };
  const handleSelectStockExchange = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setStockExchangeId(selectedOption.value);
    setStockExchangeText(selectedOption.label);
  };
  const trustTypeData = [
    {
      value: 1,
      label: "Unite",
    },
    {
      value: 2,
      label: "Bare",
    },
    {
      value: 3,
      label: "Discretionary",
    },
  ];
  const accountTypeData = [
    {
      value: 1,
      label: "Regulated Trust",
    },
    {
      value: 2,
      label: "Licensed Trust",
    },
    {
      value: 3,
      label: "Unlicensed Trust",
    },
  ];
  const expectedAmountData = [
    {
      value: 1,
      label: "$500,000 - $50 million",
    },
    {
      value: 2,
      label: "$50 - $100 million",
    },
    {
      value: 3,
      label: "$100 million+",
    },
  ];
    const countryTypeData = [
    {
      value: 1,
      label: "Australia",
    },
    {
      value: 2,
      label: "Canada",
    },
  ];
  const handleSelectAccountType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setAccountType(selectedOption.value);
    setAccountTypeLabel(selectedOption.label);
  };
    const handleSelectCountryType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setCountryType(selectedOption.value);
    setCountryTypeLabel(selectedOption.label);
  };
  const handleSelectJointAccountUser = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setJointAccountUser(selectedOption.value);
    setJointAccountUserLabel(selectedOption.label);
  };
  const handleSelectInvestmentAmount = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setInvestmentAmount(selectedOption.value);
    setInvestmentAmountText(selectedOption.label);
  };
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setRefNumber(pasteData.split(""));
    }
    event.preventDefault();
  };
  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...refNumber];
      newOtp[index] = value;
      setRefNumber(newOtp);
      if (value && index < 6) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !refNumber[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  const handleAddFormerName = (e) => {
    if (e.key === "Enter" && newFormerName.trim() !== "") {
      setFormerNames([...formerNames, newFormerName.trim()]);
      setFormerName("");
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames(formerNames.filter((_, index) => index !== indexToRemove));
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
    setToCurrencyText(selectedOption.label);
  };
    const handleSelectTrustType = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setTrustTypeID(selectedOption.value);
    setTrustTypeText(selectedOption.label);
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
    }
    event.target.value = "";
  };
  const handlesave = () => {
    dispatch(updateFormData({ field: "companyTypeId", value: companyTypeId }));
    dispatch(
      updateFormData({ field: "companyTypeLabel", value: companyTypeText })
    );
    dispatch(
      updateFormData({ field: "companycategoryId", value: accountType })
    );
    dispatch(
      updateFormData({ field: "companycategoryLabel", value: accountTypeLabel })
    );

    dispatch(updateFormData({ field: "refNumber", value: refNumber }));
    dispatch(updateFormData({ field: "advisorName", value: advisorName }));
    dispatch(updateFormData({ field: "preview", value: preview }));
    dispatch(updateFormData({ field: "fullName", value: fullName }));
    dispatch(updateFormData({ field: "formerNames", value: formerNames }));
    dispatch(updateFormData({ field: "clientId", value: clientId }));
    dispatch(
      updateFormData({ field: "businessNature", value: businessNature })
    );
    dispatch(
      updateFormData({ field: "businessNatureText", value: businessNatureText })
    );
    dispatch(updateFormData({ field: "activity", value: activity }));
    dispatch(updateFormData({ field: "activityText", value: activityText }));
    dispatch(updateFormData({ field: "otherActivity", value: otherActivity }));
    dispatch(updateFormData({ field: "DoI", value: DoI }));
    dispatch(
      updateFormData({ field: "foreignRegistered", value: foreignRegistered })
    );
    dispatch(
      updateFormData({
        field: "companyRegistrationNumber",
        value: companyRegistrationNumber,
      })
    );
    dispatch(
      updateFormData({ field: "foreignAddress", value: foreignAddress })
    );
    dispatch(
      updateFormData({ field: "registeredAddress", value: registeredAddress })
    );
    dispatch(
      updateFormData({ field: "principalAddress", value: principalAddress })
    );
    dispatch(updateFormData({ field: "stateId", value: stateId }));
    dispatch(updateFormData({ field: "stateText", value: stateText }));
    dispatch(updateFormData({ field: "abn", value: abn }));
    dispatch(updateFormData({ field: "acn", value: acn }));
    dispatch(
      updateFormData({ field: "stockRegistered", value: stockRegistered })
    );
    dispatch(
      updateFormData({ field: "stockExchangeId", value: stockExchangeId })
    );
    dispatch(
      updateFormData({ field: "stockExchangeText", value: stockExchangeText })
    );
    dispatch(updateFormData({ field: "arbn", value: arbn }));
    dispatch(
      updateFormData({ field: "companySecretary", value: companySecretary })
    );
    dispatch(
      updateFormData({ field: "companyWebsite", value: companyWebsite })
    );
    dispatch(updateFormData({ field: "toCurrency", value: toCurrency }));
    dispatch(
      updateFormData({ field: "toCurrencyText", value: toCurrencyText })
    );
    dispatch(updateFormData({ field: "source", value: source }));
    dispatch(
      updateFormData({ field: "investmentAmount", value: investmentAmount })
    );
    dispatch(
      updateFormData({
        field: "investmentAmountText",
        value: investmentAmountText,
      })
    );
    dispatch(
      updateFormData({ field: "transactionLevel", value: transactionLevel })
    );
    dispatch(updateFormData({ field: "agentName", value: agentName }));

    dispatch(updateFormData({ field: "agentAddress", value: agentAddress }));
    dispatch(updateFormData({ field: "EIN", value: EIN }));
        dispatch(updateFormData({ field: "countryCode", value: countryCode }));
    dispatch(updateFormData({ field: "countryCodeText", value: countryCodeText }));


  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/briefcase.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Corporate Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      Select the type of trust
                      <span className="text-red-500">*</span>
                    </>
                  }
                  options={accountTypeData}
                  onSelect={handleSelectAccountType}
                  preselectedValue={preselectedAccountType}
                />
              </div>
                <div className="">
                <Dropdown
                  label={
                    <>
                      Country in which the trust was established
                      <span className="text-red-500">*</span>
                    </>
                  }
                  options={countryTypeData}
                  onSelect={handleSelectCountryType}
                  preselectedValue={preselectedCountryType}
                />
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col md:px-4">
              <div className="mb-2 w-full">
                <label
                  htmlFor="custodianFee"
                  className="text-left text-sm text-labelColour block w-full"
                >
                  Advisor Ref No
                </label>
                <p className="text-[#868686] text-xs mt-1 w-full break-words leading-snug">
                  Please enter the advisor reference number if you have been
                  provided with one.
                </p>
              </div>

              <div className="flex w-full flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
                {/* Input Fields */}
                <div
                  onPaste={handlePaste}
                  className="flex mb-2 justify-center flex-wrap gap-2"
                >
                  {refNumber.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className={`w-8 h-8
            dark:bg-[#101010] ${digit ? "border-[#003478]" : "grey"}
            dark:border-[#4F4F4F] appearance-none border-2 rounded px-2 py-0.5
            dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black 
            text-base font-medium leading-tight focus:outline-none focus:shadow-outline input-main`}
                    />
                  ))}
                </div>

                {/* Save Button */}
                <button className="bg-black text-white text-sm rounded-full px-6 py-2 w-full md:w-auto">
                  Save
                </button>
              </div>

              <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                <span className="text-sm text-labelColour font-medium">
                  Advisor Name:
                </span>
                {isAdvisorExist && advisorName && (
                  <img src="/valid.svg" alt="User Icon" className="w-4 h-4" />
                )}
                {!isAdvisorExist && advisorName && (
                  <img src="/danger.svg" alt="User Icon" className="w-4 h-4" />
                )}
                <span
                  className={`text-sm ml-2 font-medium ${
                    isAdvisorExist
                      ? "text-black text-sm"
                      : "text-[#FF5050] text-xs"
                  }`}
                >
                  {advisorName}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white">
            <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* Profile Picture Section */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <label
                  htmlFor="firstName"
                  className="block dark:text-gray-300 text-labelColour  color-test text-sm mb-1"
                >
                  Trust Logo <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <img
                      src={preview}
                      alt="Avatar"
                      className="w-14 h-14 rounded-full"
                    />
                  </div>
                  <div className="flex flex-col space-y-1">
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                    <button
                      onClick={handleUploadClick}
                      className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full"
                    >
                      Upload from Device
                    </button>
                  </div>
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="firstName"
                    className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Full Name of the Trust
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="fullName"
                    name="firstName"
                    type="text"
                    value={fullName}
                    placeholder="Your Full Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setfullName(e.target.value)}
                  />
                </div>
                 <div className="mt-4">
                  <label
                    htmlFor="firstName"
                    className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    The full name of the settlor of the trust
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="fullName"
                    name="firstName"
                    type="text"
                    value={fullSettlorName}
                    placeholder="Your Full Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setFullSettlorName(e.target.value)}
                  />
                </div>
              </div>

              <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                <div className="">
                  <Dropdown
                    label={
                      <>
                        Select the type Trust Category
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={trustTypeData}
                    onSelect={handleSelectTrustType}
                  />
                </div>
        <div className="mt-4">
                    <label
                      htmlFor="firstName"
                      className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Trust's Registered Address
                      <span className="text-red-500">*</span>
                    </label>
                    <AddressAutocomplete
                      onSelect={(addr) => setRegisteredAddress(addr)}
                    />
                  </div>
                <div className="">
                  <label className="block mb-1 text-sm text-[#464646] whitespace-normal words-break">
                    All business names used by the trust and any other name under which the trust operates
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1 border rounded-md border-gray-300 p-2 flex flex-wrap gap-2">
                    {formerNames.map((formerName, index) => (
                      <div
                        key={index}
                        className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                      >
                        <span>{formerName}</span>
                        <button
                          type="button"
                          onClick={() => handleRemoveFormerName(index)}
                          className="ml-2 text-gray-700 hover:text-gray-700"
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                    <input
                      type="text"
                      value={newFormerName}
                      onChange={(e) => setFormerName(e.target.value)}
                      onKeyDown={handleAddFormerName}
                      placeholder="Add name"
                      className="border-none focus:outline-none flex-grow text-sm"
                    />
                  </div>
                </div>
              </div>

              {/* Client ID Section */}
              <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Client ID
                    </label>
                    <input
                      id="refId"
                      type="text"
                      value={clientId}
                      disabled={true}
                      className="bg-[#F9F9F9] p-2 text-black font-medium rounded-md text-md"
                      placeholder="INV1947534324"
                    />
                    <div className="mt-4">
                      <label
                        htmlFor="setRecommendedBy"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Recommended by <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <input
                          id="setRecommendedBy"
                          name="setRecommendedBy"
                          type="text"
                          value={recommendedBy}
                          placeholder="Enter ID"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white 
                text-black text-base font-medium 
               dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none w-full py-2 pr-10 pl-3
               leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) => setRecommendedBy(e.target.value)}
                        />

                        {/* Right Icon/Image */}
                        <img
                          src="/tick-circle.svg" // replace with your image path
                          alt="icon"
                          className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 cursor-pointer"
                        />
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
            <div className="bg-white shadow-md rounded-md p-4 mt-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
            <div className="">
                        <label
                          htmlFor="RegistrationNumber"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Registration Number<span className="text-red-500">*</span>
                        </label>
                        <input
                          id="RegistrationNumber"
                          name="RegistrationNumber"
                          type="text"
                          value={registrationNumber}
                          placeholder="Enter Registration Number"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) => setRegistrationNumber(e.target.value)}
                        />
                      </div>
                      {countryType==1&&
                      <>
                        <div className="mt-4">
                    <label
                      htmlFor="source"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Source of the funds including its origin
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="source"
                      name="source"
                      type="text"
                      value={source}
                      placeholder="Enter Source"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setSource(e.target.value)}
                    />
                  </div>
                   <div className="mt-4">
                    <label
                      htmlFor="source"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Purpose of Opening Caprock Account
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="purpose"
                      name="purpose"
                      type="text"
                      value={purpose}
                      placeholder="Enter purpose"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setPurpose(e.target.value)}
                    />
                  </div>
                  </>
                      }
                       
                </div>

                <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
               <div className="">
                  <Dropdown
                    label={
                      <>
                        Business Nature
                        <span className="text-red-500"> *</span>
                      </>
                    }
                    options={businessNatureData}
                    onSelect={handleSelectBusinessNature}
                  />
                </div>
                 {countryType==1&&
                      <>
                        <div className="mt-4">
                    <label
                      htmlFor="source"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      ABN
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="abn"
                      name="abn"
                      type="text"
                      value={abn}
                      placeholder="Enter ABN"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setAbn(e.target.value)}
                    />
                  </div>
                    <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Upload ABN Lookup Extract<span className="text-red-500">*</span>
                  </label>
                </div>
                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={abnFileRef}
                    onChange={handleFileChangeAbn}
                    className="hidden"
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileAbn && (
                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <div className="flex-col flex">
                      <span className="text-black">{fileAbn.name}</span>
                      <span className="text-[#46DA55] text-xs">
                        Upload Completed
                      </span>
                    </div>
                    <button
                      onClick={handleDeleteFileAbn}
                      className="text-red-500 flex-shrink-0 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Success Icon"
                        className="h-4 w-4 flex-shrink-0"
                      />
                    </button>
                  </div>
                )}
                  </>
                      }
                </div>

                {/* Client ID Section */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                   <div className="">
                  <Dropdown
                    label={
                      <>
                       Nature of the business activities conducted by the trust
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={businessActivityData}
                    onSelect={handleSelectActivity}
                  />
                </div>
                {activity == 6 && (
                  <div className="mt-4">
                    <label
                      htmlFor="others"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Please mention business activity
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="others"
                      name="others"
                      type="text"
                      value={otherActivity}
                      placeholder="Other activity"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setOtherActivity(e.target.value)}
                    />
                  </div>
                )}
                </div>
              </div>
            </div>

            <div className="bg-white shadow-md rounded-md p-4 mb-4 mt-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                  <div className="">
                    <Dropdown
                      label={
                        <>
                          Default Investment Currency
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={currencyData}
                      search={true}
                      preselectedValue={preselectedcashCurrency}
                      onSelect={handleSelectToCurrency}
                      colorLabel=""
                    />
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="source"
                      className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Nature and level of the intended transaction behaviour
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="transactionLevel"
                      name="transactionLevel"
                      type="text"
                      value={transactionLevel}
                      placeholder="Enter transaction behaviour"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setTransactionLevel(e.target.value)}
                    />
                  </div>
                </div>

                <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                  <div className="">
                    <label
                      htmlFor="source"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Source of the funds including its origin
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="source"
                      name="source"
                      type="text"
                      value={source}
                      placeholder="Enter Source"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setSource(e.target.value)}
                    />
                  </div>
                </div>

                {/* Client ID Section */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                  <div className="">
                    <Dropdown
                      label={
                        <>
                          Expected Investment Amount
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={expectedAmountData}
                      onSelect={handleSelectInvestmentAmount}
                    />
                  </div>
                </div>
              </div>
            </div>
            {accountType != 1 && (
              <div className="bg-white shadow-md rounded-md p-4 mb-4 mt-4">
                <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                  <h1 className="text-xl font-medium mb-2">
                    Details of the company's local agent in Australia (if any)
                  </h1>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    <div className="">
                      <label
                        htmlFor="agentName"
                        className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Full Name
                      </label>
                      <input
                        id="agentName"
                        name="agentName"
                        type="text"
                        value={agentName}
                        placeholder="Enter name"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setAgentName(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="space-y-4 lg:pt-4 pt-0 border-r-0  border-gray-300 px-4 md:pl-0 pr-4">
                    <div className="">
                      <label
                        htmlFor="source"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Address
                      </label>
                      <AddressAutocomplete
                        onSelect={(addr) => setAgentAddress(addr)}
                      />
                    </div>
                  </div>

                  {/* Client ID Section */}
                  <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4"></div>
                </div>
              </div>
            )}
      </div>
      {foreignRegistered === "no" && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">Unable to Proceed</h2>
            <p class="text-sm text-black mb-2">
              We regret to inform you that your company is not eligible to
              register as a corporate customer since it is not currently
              registered under the relevant foreign registration body!
            </p>
            <p class="text-sm text-black mb-4">
              If you accidentally chose "No". Kindly click on “Continue
              Application” and proceed to enter your Tax ID information by
              selecting "Yes".{" "}
            </p>

            <div class="flex justify-center space-x-4">
              <button
                onClick={() => {
                  navigate("/login");
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                Back To Login
              </button>
              <button
                onClick={() => {
                  setForeignRegistered("yes");
                }}
                class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Continue Application
              </button>
            </div>
          </div>
        </div>
      )}
      <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
          {/* Save as Draft */}
          <button
            onClick={() => {}}
            className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
          >
            <span>Save as Draft</span>
          </button>

          <ConfirmContinueButton
            onContinue={handleContinue}
            buttonText="Continue"
            confirmTitle="Save Section"
            confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
          />
        </div>
      </footer>
    </div>
  );
};

export default TrustInfo;
